import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnBatchInput, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import set from 'lodash/set';
import { handleBizExtendComponentProps } from '../../plugin';
import { setAdvancedConfigToProps } from '@/common/util/util';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'CnBatchInput',
    component: CnBatchInput,
    formComponent: formComponentMap.CnBatchInput,
    formItemBeforeHandler: (formItem) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            const { hasClear, placeholder, autoCheckEmpty } = componentProps || {};
            if (hasClear) {
                set(componentProps, 'inputProps.hasClear', hasClear);
            }
            if (placeholder) {
                set(componentProps, 'inputProps.placeholder', placeholder);
            }
            if (autoCheckEmpty) {
                set(componentProps, 'inputProps.autoCheckEmpty', autoCheckEmpty);
            }
            handleBizExtendComponentProps(componentProps, 'CnBatchInput');
            setAdvancedConfigToProps(componentProps);
        }
    },
    filterItemBeforeHandler: () => { },
};
